var AtLeastOneTrueValidation = /** @class */ (function () {
    function AtLeastOneTrueValidation() {
    }
    AtLeastOneTrueValidation.validate = function (formGroup) {
        var controls = formGroup.value;
        var isAtLeastOneTrue = Object.values(controls).some(function (value) { return value === true; });
        return isAtLeastOneTrue ? null : { atLeastOneTrue: true };
    };
    return AtLeastOneTrueValidation;
}());
export { AtLeastOneTrueValidation };
